module.exports = ".rating {\r\n    width: 30px;\r\n    text-align: center;\r\n}\r\n\r\ndiv.col-md-4 {\r\n    padding-top: 5px;\r\n    padding-bottom: 5px;\r\n}"